module.exports = __webpack_public_path__ + "img/groupworks@2x.ffaba281.png";